﻿function showNearbyEventMap() {
    const lat = document.getElementById('Lat').value;
    const lng = document.getElementById('Lng').value;

    const parseCoordinate = (value) => {
        if (!value) {
            return NaN;
        }

        // Normalize decimal separator for locales that render decimals with comma (e.g. sv-SE).
        return parseFloat(String(value).trim().replace(',', '.'));
    };

    const position = {
        lat: parseCoordinate(lat),
        lng: parseCoordinate(lng)
    };

    if (Number.isNaN(position.lat) || Number.isNaN(position.lng)) {
        return;
    }

    const map = new google.maps.Map(document.getElementById('nearbyEventMap'), {
        center: position,
        zoom: 8,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: false,
        fullscreenControl: true
    });

    var marker = new google.maps.Marker({
        position,
        map
    });

    marker.setPosition(position);
    marker.setMap(map);
}

window.showNearbyEventMap = showNearbyEventMap;
